<opac-text-input
  #passwordEl
  autocomplete="off"
  [disabled]="isDisabled"
  [icon]="type === 'text' ? 'visibility' : 'visibility_off'"
  [id]="id"
  [invalid]="invalid"
  [name]="name"
  [(ngModel)]="value"
  [readonly]="readonly"
  [required]="required"
  [type]="type"
  (blur)="handleOnTouch($event)"
  (input)="onChange(value)"
  (iconClick)="handleIconClick()"
>
  <ng-content></ng-content>

  <ng-content select="[slot='error']" slot="error"></ng-content>
</opac-text-input>
